// eslint-disable-next-line import/prefer-default-export
export const SET_CLIENT_LIST = 'SET_CLIENT_LIST';
export const SET_CLIENT_INFO = 'SET_CLIENT_INFO';
